export default {
  functional: true,

  name: 'list-tile-action',

  render (h, { data, children }) {
    data.staticClass = data.staticClass ? `list__tile__action ${data.staticClass || ''}` : 'list__tile__action'
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack'

    return h('div', data, children)
  }
}



// WEBPACK FOOTER //
// ./src/components/lists/VListTileAction.js